import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const NoButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main danger-button yes-no-button'} onClick={onClick}>
            {t('common:buttons.no')}
        </button>
    );
};